import React from "react";

export const useProgressDisplayed = (progress: number, minDisplayedValue = 0) => {
  const progressDisplayed = React.useMemo(() => {
    if (progress === 0 || progress === 1) {
      return progress;
    }

    return Math.max(minDisplayedValue, Math.min(1 - minDisplayedValue, progress));
  }, [progress, minDisplayedValue]);

  return {
    progress: progressDisplayed,
  };
};
